import { useRouter } from "components/hooks";
import NotFound from "pages/NotFound";
import AnalyticsdDataProvider from "./AnalyticsDataProvider";
import AudienceAnalytics from "./AudienceAnalytics/AudienceAnalytics";
import BrandAnalytics from "./BrandAnalytics";
import MagnetAnalytics from "./MagnetAnalytics";

function AnalyticsSection() {
  const router = useRouter();
  const { analyticsSection } = router.query;

  switch (analyticsSection) {
    case "audience":
      return <AudienceAnalytics />;
    case "brand":
      return <BrandAnalytics />;
    case "magnet":
      return <MagnetAnalytics />;
    default:
      return <NotFound />;
  }
}

export default function Analytics() {
  return (
    <AnalyticsdDataProvider>
      <AnalyticsSection />
    </AnalyticsdDataProvider>
  );
}
